import { render, staticRenderFns } from "./ExternalRequestChart.vue?vue&type=template&id=5b382863&scoped=true&"
import script from "./ExternalRequestChart.vue?vue&type=script&lang=js&"
export * from "./ExternalRequestChart.vue?vue&type=script&lang=js&"
import style0 from "./ExternalRequestChart.vue?vue&type=style&index=0&id=5b382863&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b382863",
  null
  
)

export default component.exports